










import {
    defineComponent,
    watch,
    onMounted,
    ref,
    computed
} from '@vue/composition-api';
import uaParser from 'ua-parser-js';

export default defineComponent({
    props: {
        animationConfig: {
            type: Object,
            default: () => ({}),
        },
    },
    emits: ['start', 'complete'],
    setup(props, ctx) {
        const isShow = ref(false);
        const lottieEl = ref<HTMLDivElement>();
        let animation;
        let hasRendered = false;

        const cpus = ref(0);
        const parser = uaParser();
        const { os } = parser;

        const isLowerLowerPerfemence = computed(() => {
            const { name, version = '' } = os || {};
            const majorVer = +version?.split('.')[0];
            const isAndroid = name?.toLowerCase() === 'android';
            return (isAndroid && majorVer <= 6) || (cpus.value <= 4);
        });

        const playAnimation = () => {
            const { isDemoted, lottieData, demotionLottieData } = configTemp.value || {};
            const data = isDemoted && isLowerLowerPerfemence.value ? demotionLottieData : lottieData;
            const { path, assetsPath } = data || {};
            let config;
            if (path) {
                config = {
                    renderer: 'html',
                    loop: false,
                    autoplay: false,
                    path,
                };
                if (assetsPath) {
                    config.assetsPath = assetsPath;
                }
            }

            if (config && !hasRendered) {
                isShow.value = true;
                ctx.emit('start', config);
                config.container = lottieEl.value!;
                const lottie = require('lottie-web');
                animation = lottie.loadAnimation((config));
                animation.play();
                animation.addEventListener('complete', () => {
                    ctx.emit('complete', config);
                    isShow.value = false;
                });
                hasRendered = true;
                // 以防没隐藏，定时主动隐藏一次
                setTimeout(() => {
                    isShow.value = false;
                }, 10000);
            }
        };

        const configTemp = ref(null);
        watch(() => configTemp.value, val => {
            if (val) {
                playAnimation();
            }
        });

        onMounted(() => {
            cpus.value = navigator?.hardwareConcurrency ?? 0;
            configTemp.value = props.animationConfig;
        });

        return {
            isShow,
            lottieEl,
        };
    },
});
